import { render, staticRenderFns } from "./board_targetpage.vue?vue&type=template&id=612c31a8&"
import script from "./board_targetpage.vue?vue&type=script&lang=js&"
export * from "./board_targetpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports